export function prefixPath(prefix: string, path: string): string {
	return [prefix, path].filter(Boolean).join("/");
}
